const isNullOrUndefined = (value: any): value is undefined => {
    return typeof value === "undefined" || value === null;
  };
  
export default isNullOrUndefined;